import { FC, useCallback } from "react";
import { Avatar, Box, Card, Divider, Stack, Typography } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { isMobile } from 'react-device-detect';
import { LotContact } from "prembid-shared-library-npm/types";
import { useLotContactListStyles } from "../LotContactList.styles";
import { RootState } from "../../../../store/Store";
import { useSelector } from "react-redux";

export type LotContactDisplayProps = LotContact;

const LotContactDisplay: FC<LotContactDisplayProps> = ({ firstName, lastName, email, imageUrl, phoneNumber }) => {
    const { classes } = useLotContactListStyles();

    const { settings } = useSelector((state: RootState) => state.settings);

    const renderPhoneNumber = useCallback(() => {
        return (
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                className={classes.link}
            >
                <CallIcon className={classes.buttonIcon} style={{ background: settings?.Styles?.Primary }} />
                <Typography
                    variant="caption"
                    className={classes.buttonLabel}
                    style={{
                        overflow: 'hidden',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        wordWrap: 'break-word'
                    }}
                >
                    {isMobile ? 'Call' : phoneNumber}
                </Typography>
            </Stack>
        );
    }, [classes.buttonIcon, classes.buttonLabel, classes.link, phoneNumber, settings?.Styles?.Primary]);

    return (
        <Card raised={true}>
            <Stack direction={'row'}>
                <Box className={classes.imageContainer}>
                    <Avatar src={imageUrl} className={classes.image} />
                </Box>
                <Box className={classes.infoContainer}>
                    <Box>
                        <Typography
                            variant="inherit"
                            className={classes.contactHeading}
                            style={{
                                overflow: 'hidden',
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                wordWrap: 'break-word'
                            }}
                        >
                            {`${firstName} ${lastName}`}
                        </Typography>
                        <Stack direction={'column'} className={classes.contactButtonsContainer}>
                            {isMobile ? (
                                <a href={`tel:${phoneNumber}`}>
                                    {renderPhoneNumber()}
                                </a>
                            ) : (
                                renderPhoneNumber()
                            )}
                            <a href={`mailto:${email}`}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    className={classes.link}
                                >
                                    <MailOutlineIcon className={classes.buttonIcon} style={{ background: settings?.Styles?.Primary }} />
                                    <Typography
                                        variant="caption"
                                        className={classes.buttonLabel}
                                        style={{
                                            overflow: 'hidden',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            wordWrap: 'break-word'
                                        }}
                                    >
                                        {email}
                                    </Typography>
                                </Stack>
                            </a>
                        </Stack>
                    </Box>
                </Box>
            </Stack>
        </Card>
    );
};

export default LotContactDisplay;